import React from "react"
import NoteBuilderErrors from "./NoteBuilderErrors"
import Switch from "../Switch/Switch"
import FileUploadGroupBuilder from "../FileUploadGroupBuilder/FileUploadGroupBuilder"
import RichTextEditor from '../RichTextEditor/RichTextEditor'
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import ModalButtons from "../ModalButtons/ModalButtons"

class NoteBuilder extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      note_obj: this.props.note ? this.props.note : {
        note: '',
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null
      },
      file_upload_group: this.props.file_upload_group ? this.props.file_upload_group : { file_uploads: [] },
      loading: false,
      errors: [],
    }

    this.onChangeNote = this.onChangeNote.bind(this);
    this.onChangeFlagged = this.onChangeFlagged.bind(this);
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.note !== prevState.note_obj) {

      return { note_obj: nextProps.note };
    } else if (nextProps.file_upload_group && nextProps.file_upload_group !== prevState.file_upload_group) {
      return { file_upload_group: nextProps.file_upload_group }
    }
    else return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.note !== this.props.note) {

      this.setState({ note_obj: this.props.note });
    } else if (prevProps.file_upload_group !== this.props.file_upload_group) {
      this.setState({ file_upload_group: this.props.file_upload_group })
    }
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          self.onSave();
          return false;
        },
      },
    ]

    return (
      <div className="note-builder">
        {this.renderErrors()}
        <div className="row">
          {this.renderNotes()}
          {this.renderFlagged()}
        </div>
        <br />
        <div className="row">
          {this.renderFileUploadGroupBuilder()}
        </div>
        <LoadingSpinner show={this.state.loading} />
        {this.props.ignoreModalButtons ? null : <ModalButtons loading={this.state.loading} buttons={this.props.buttons ? this.props.buttons : buttons} />}
      </div>
    )
  }

  renderErrors() {
    var errors = NoteBuilderErrors.general(this.state.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldErrors(field) {
    if (this.state.errors && this.state.errors[field]) {
      var idx = 0;
      var errors = this.state.errors[field].map((error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, classname) {
    var classname = classname || 'form-control';
    if (this.state.errors && Object.keys(this.state.errors).length && this.state.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderFlagged() {
    return (
      <div className="col-md-2">
        <div className="form-group">
          <label>{I18n.t('flagged')}</label> <span className="ss-help help" title={I18n.t('flagged_helper_text')}></span>
          <Switch onText="yes" switchId="note-switch" name="note-switch" offText="no" value={this.state.note_obj && this.state.note_obj.flagged ? this.state.note_obj.flagged : false} onChange={this.props.onChangeFlagged ? this.props.onChangeFlagged : this.onChangeFlagged} />
        </div>
      </div>
    )
  }

  renderNotes() {
    var self = this;
    return (
      <div className="col-md-10">
        <div className="form-group">
          {
            this.props.ok_to_edit || this.props.new_record
              ?
              <RichTextEditor name="note" className={this.renderFieldClasses('note', 'form-control')} body={self.state.note_obj && self.state.note_obj.note ? self.state.note_obj.note : ''} onChange={self.props.onChangeNote ? self.props.onChangeNote : self.onChangeNote} height={350} />
              :
              <div style={{ 'whiteSpace': 'pre-line' }}>{self.state.note_obj.note}</div>
          }
          {this.renderFieldErrors('note')}
        </div>
      </div>
    );
  };

  renderFileUploadGroupBuilder() {
    // console.log("this.props.ok_to_edit == false", this.props.ok_to_edit == false);
    return (
      <div className="col-md-12">
        <FileUploadGroupBuilder nested={true} read_only={!this.props.ok_to_edit && !this.props.new_record ? true : null} onChange={this.props.onChangeFileUploadGroup ? this.props.onChangeFileUploadGroup : this.onChangeFileUploadGroup} file_upload_groups={this.state.file_upload_group ? [this.state.file_upload_group] : [{ file_uploads: [] }]} />
      </div>
    )
  }

  onChangeFlagged(input) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = input.target.checked
    this.setState({ note_obj: note_obj });
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = this.state.note_obj
      note_obj.note = noteText
      this.setState({
        note_obj: note_obj
      })
    }
  }

  onChangeFileUploadGroup(file_upload_group) {
    if (file_upload_group) {
      this.setState({
        file_upload_group: file_upload_group,
      })
    }
  }

  onSave() {
    var self = this;
    this.setState({ loading: true });

    $.ajax({
      type: this.props.new_record ? 'POST' : 'PUT',
      url: this.props.form_action,
      data: {
        note: this.state.note_obj,
        file_upload_group_file_uploads: this.state.file_upload_group && this.state.file_upload_group.file_uploads ? this.state.file_upload_group.file_uploads.map(function (file_upload) { return file_upload.id; }) : null,
      },
    }).done((data) => {
      window.parent.$(window.parent).trigger('noteSaved', data)
      top.window.refreshSystemNotificationsBadgeNumber();

      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('note_saved_successfully'))
      }

      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    }).catch((data) => {
      if (data && data.responseJSON) {
        this.setState({ errors: data.responseJSON, loading: false })
        $('.modal-body').scrollTop(0);
      }
    });
  }

}

export default NoteBuilder